module.exports = __webpack_public_path__ + "assets/icons/Icon-EU.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/Icon-EU.png
// module id = 527
// module chunks = 0